// @ts-check

const openers = document.querySelectorAll("[data-modal]");
const closers = document.querySelectorAll(".modal-close, .button-modal-close");
const modals = document.querySelectorAll(".modal");
const body = document.body;

openers.forEach((opener) => {
  opener.addEventListener("click", () => {
    const modalId = opener.dataset.modal;
    const modal = document.getElementById(modalId);
    modal.classList.add("active");
    body.classList.add("modal-open");
  });
});

const showreelModal = document.getElementById("modal-video");

if (showreelModal) {
  const showreelVideo = showreelModal.querySelector("video");
  const showreelVideoButtons = document.querySelectorAll(
    "[data-modal='modal-video'][data-modal-video]"
  );

  showreelVideoButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const videoSource = button.dataset.modalVideo;
      const sourcesList = JSON.parse(videoSource);

      console.log(sourcesList);

      showreelVideo.innerHTML = sourcesList.map(
        item => `<source src="${item['video_link']}">`
      ).join('');
    });
  });
}

closers.forEach((closer) => {
  closer.addEventListener("click", (e) => {
    const modal = e.currentTarget.closest(".modal");
    closeModal(modal);
  });
});

modals.forEach((modal) => {
  modal.addEventListener("click", (e) => {
    if (e.target === e.currentTarget) {
      closeModal(modal);
    }
  });
});

function closeModal(modal) {
  modal.classList.remove("active");
  body.classList.remove("modal-open");
}
